import { useRef } from "react";
import { motion, useInView } from "framer-motion";

export default function LogoAssembly({ className = "opacity-[0.14]" }) {
  const ref = useRef(null);
  const inView = useInView(ref, { margin: "-120px" });

  const N = 24;
  const wedges = Array.from({ length: N }, (_, i) => {
    const ang = -Math.PI + (2 * Math.PI) * (i + 0.5) / N;
    const dist = 320 + (i % 4) * 70;
    const dx = Math.cos(ang) * dist;
    const dy = Math.sin(ang) * dist;
    const spin = (i % 2 ? 1 : -1) * (35 + (i % 5) * 12);
    return {
      src: `/dp-wedge-${String(i).padStart(2, "0")}.png`,
      hidden: { x: dx, y: dy, rotate: spin, scale: 0.45, opacity: 0 },
      show: {
        x: 0, y: 0, rotate: 0, scale: 1, opacity: 1,
        transition: { duration: 1.0, delay: i * 0.13, ease: [0.34, 1.25, 0.5, 1] },
      },
    };
  });

  const centerDelay = N * 0.13 + 0.2;

  return (
    <div
      ref={ref}
      className={`pointer-events-none absolute inset-0 flex items-center justify-center z-0 ${className}`}
      aria-hidden="true"
    >
      <motion.div
        className="relative w-[95vw] max-w-[860px] aspect-square"
        style={{ transformOrigin: "center" }}
        animate={inView ? { rotate: 360 } : { rotate: 0 }}
        transition={
          inView
            ? { duration: 55, ease: "linear", repeat: Infinity, delay: centerDelay + 0.9 }
            : { duration: 0.3 }
        }
      >
        {wedges.map((p, i) => (
          <motion.img
            key={i}
            src={p.src}
            alt=""
            variants={{ hidden: p.hidden, show: p.show }}
            initial="hidden"
            animate={inView ? "show" : "hidden"}
            className="absolute inset-0 w-full h-full object-contain select-none"
          />
        ))}
        <motion.img
          src="/dp-center.png"
          alt=""
          variants={{
            hidden: { scale: 0, rotate: -40, opacity: 0 },
            show: {
              scale: 1, rotate: 0, opacity: 1,
              transition: { type: "spring", stiffness: 130, damping: 12, delay: centerDelay },
            },
          }}
          initial="hidden"
          animate={inView ? "show" : "hidden"}
          className="absolute inset-0 w-full h-full object-contain select-none"
        />
      </motion.div>
    </div>
  );
}
